import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router"
import { NzMessageService } from 'ng-zorro-antd/message';
import { AuthService } from '../../services/auth.service';
import { Login } from '../../login/login';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'app-alteracao-senha',
    templateUrl: './alteracao-senha.component.html',
    styleUrls: ['./alteracao-senha.component.css'],
    standalone: false
})
export class AlteracaoSenhaComponent implements OnInit {
  validateForm!: UntypedFormGroup;
  token;
  private loggedIn = new BehaviorSubject<boolean>(false);

  constructor(
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private message: NzMessageService,
    private authService: AuthService) {

    this.route.params.subscribe(res => this.token = res.token);


  }

  confirmationValidator = (control: UntypedFormControl): { [s: string]: boolean } => {

    if (!control.value) {
      return { required: true };
    } else if (control.value !== this.validateForm.controls.password.value) {
      return { confirm: true, error: true };
    }

    return {};
  };

  submitForm(): void {
    for (const i in this.validateForm.controls) {
      this.validateForm.controls[i].markAsDirty();
      this.validateForm.controls[i].updateValueAndValidity();
    }

    if (this.validateForm.valid) {
      let id = this.message.loading('Alterando senha...').messageId;
      this.authService.resetPasswordAlterarSenha(this.validateForm.value).subscribe((l: any) => {
        this.message.remove(id);
        this.message.success('Senha redefinida com sucesso!');
        this.router.navigate(['/login']);
      }, (err: any) => {
        this.message.remove(id);
        this.message.error('Houve uma falha ao tentar redefinir sua senha, solicite uma nova alteração de senha!');
      });
    }
  }

  ngOnInit(): void {
    this.validateForm = this.fb.group({
      email: [null, [Validators.email, Validators.required]],
      password: [null, [Validators.required]],
      password_confirmation: [null, [this.confirmationValidator]],
      token: [this.token, [Validators.required]]
    });
  }

}
